import styled from 'styled-components'

import { Chip } from '@components/ui/Chip'

export const FilterChip = styled(Chip).attrs(({ theme }) => ({
  bold: true,
  color: theme.colors.gray[50],
  size: 'small',
  variant: 'outlined',
}))``
